import React from 'react';
import { motion } from 'framer-motion';
import { Badge } from '../ui';
import {
  getVisionBadgeState,
  shouldShowAutoDetectedExpiryNote,
  formatVisionDate,
} from '../../utils/documentVision';

const spring = { type: 'spring', stiffness: 90, damping: 22 };

export default function VisionVerificationBadge({
  doc,
  showFailureReason = true,
  showAutoExpiry = true,
  compact = false,
}) {
  const state = getVisionBadgeState(doc);
  const showReason = showFailureReason && state.status === 'unverified' && doc?.visionFailureReason;
  const showExpiryNote = showAutoExpiry && shouldShowAutoDetectedExpiryNote(doc);

  return (
    <motion.div
      className={`vision-verification-badge${compact ? ' vision-verification-badge--compact' : ''}`}
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={spring}
      layout
    >
      <Badge variant={state.variant} className="vision-verification-badge__pill">
        {state.label}
      </Badge>
      {showReason ? (
        <motion.p
          className="vision-verification-badge__reason"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ ...spring, delay: 0.05 }}
        >
          {doc.visionFailureReason}
        </motion.p>
      ) : null}
      {showExpiryNote ? (
        <motion.p
          className="vision-verification-badge__auto-expiry"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ ...spring, delay: 0.08 }}
        >
          Expiry auto-detected: {formatVisionDate(doc.visionExtractedExpiry)}
        </motion.p>
      ) : null}
    </motion.div>
  );
}
